import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Empty, Alert,Select } from 'antd';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import './style.scss';
import Constants from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ZohoConnectionList from '../ZohoConnectionList';
import PRZSelect from '../../../../Common/UI/PRZSelect';

/**
 *
 */
function ZohoHome({
  getZohoConnections, user, getZohoConnectionsLoading, zohoConnections,
}) {
  const [isUserAllReadyConnected, setIsUserAllReadyConnected] = React.useState(false);
  const [selectedDataCenter, setSelectedDataCenter] = React.useState('india');

  useEffect(() => {
    getZohoConnections(user?.tenant_info?.org_id);
  }, []);

  const dataCenters = [
    { label: 'India', value: 'india' }, // India as the first option
    { label: 'United States', value: 'united_states' },
    { label: 'Europe', value: 'europe' },
    { label: 'Australia', value: 'australia' },
    { label: 'Japan', value: 'japan' },
    { label: 'Canada', value: 'canada' }
  ];

  useEffect(() => {
    if (zohoConnections?.length) {
      setIsUserAllReadyConnected(true);
    }
  }, [zohoConnections]);

  return (
    <div className="zoho-integration-wrapper">
      <div className="zoho-integration__heading">Zoho Books Integration </div>

      { !getZohoConnectionsLoading ? (
        <React.Fragment>
          {isUserAllReadyConnected === true && (
            <React.Fragment>
              <div className="zoho-list-wrapper">
                <Alert
                  message="Please select the organisation to be connected with procuzy account. Organisation selection is a one time process and cannot be changed once confirmed."
                  // description=""
                  type="warning"
                  showIcon
                />
              </div>
              <ZohoConnectionList setIsUserAllReadyConnected={setIsUserAllReadyConnected}/>
            </React.Fragment>

          )}
          {isUserAllReadyConnected === false
            && (
              <React.Fragment>
                <div className="no-zoho-found__wrapper">
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description=""
                  />
                  <p className="no-zoho-found__heading">Your Procuzy account is not yet connected to zoho</p>
                  <div style={{ width: '250px', margin: '0 auto' }}>
                  <p className="no-zoho-found__heading">Please Select your Data Center</p>
                  <PRZSelect
                    value={selectedDataCenter}
                    onChange={(value) => setSelectedDataCenter(value)}
                    options={dataCenters}
                  />
                  </div>
                  <div>
                    <H3Button
                      text="Connect Now"
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      onClick={() => {
                        window.location.href = `${Constants.CONNECT_TO_ZOHO}?org_id=${user?.tenant_info?.org_id}&data_center=${selectedDataCenter}&redirect_url=${window.location.protocol}//${window.location.host}/admin/integration/zoho`;
                      }}
                      customClass="zoho__location-submit"
                      isLoading={getZohoConnectionsLoading}
                      disabled={getZohoConnectionsLoading}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}

        </React.Fragment>
      ) : (
        <div
          className="zoho-list-wrapper"
        >
          {

            [1, 2, 3].map((item) => (
              <div
                key={item}
                className="loading-zoho__card"
              >
                <div className="zoho-card-spacing">

                  <div className="zoho-card-header ">

                    <div className="loadingBlock loading-zoho-header__text" />
                    <div className="loadingBlock loading-zoho-header__image"> </div>
                  </div>

                  <div className="loadingBlock loading-zoho-card__link"> </div>
                  <div className="zoho-card-footer">
                    <div
                      className="flex "
                    >
                      <p className="loadingBlock loading-zoho-card__footer" />
                    </div>
                  </div>
                </div>
              </div>

            ))

          }

        </div>
      ) }
    </div>
  );
}

const mapStateToProps = ({ ZohoIntegrationReducers, UserReducers }) => ({
  zohoConnections: ZohoIntegrationReducers.zohoConnections,
  getZohoConnectionsLoading: ZohoIntegrationReducers.getZohoConnectionsLoading,
  user: UserReducers.user,
});
const mapDispatchToProps = (dispatch) => ({
  getZohoConnections: (orgId, callback) => dispatch(ZohoIntegrationActions.getZohoConnections(orgId, callback)),
  connectToZoho: (orgId, callback) => dispatch(ZohoIntegrationActions.connectToZoho(orgId, callback)),

});
ZohoHome.propTypes = {
  user: PropTypes.any,
  zohoConnections: PropTypes.any,
  getZohoConnections: PropTypes.func,
  getZohoConnectionsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ZohoHome));
